import { render } from "./Column202506.vue?vue&type=template&id=10cedcfc&scoped=true"
import script from "./Column202506.vue?vue&type=script&lang=js"
export * from "./Column202506.vue?vue&type=script&lang=js"

import "./Column202506.vue?vue&type=style&index=0&id=10cedcfc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10cedcfc"

export default script